import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-settings',
  templateUrl: './settings.component.html'
})
export class SettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
